module.exports = __webpack_public_path__ + "img/11.153632d0.png";